import {
  Button,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import InputAdornment from "@material-ui/core/InputAdornment";
import AddIcon from "@material-ui/icons/Add";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import styles from "../../../../styles/global-styles";
import BalanceProvidersSelect from "../../../shared/selects/BalanceProvidersSelect";
import { actions } from "../../../../redux/actions/alert";
import { actions as shoppingCartActions } from "../../../../redux/actions/shoppingCart";
import { connect } from "react-redux";
import { BalanceTransferService } from "../../../../services/balanceTransfer.service";
import { AuthService } from "../../../../services/auth.service";
import { ProductService } from "../../../../services/product.service";
import { customDate } from "../../../../_utils/utils";
import StatelessTableHeadBalanceProduct from "../../../stateless/headTables/StatelessTableHeadBalanceProduct ";
import StyleTableRow from "../../../../styles/styleTableRow";
import StyledTableCell from "../../../../styles/tableCell";
import PaymentMethodSelect from "../../../shared/selects/PaymentMethodSelect";
import { SellService } from "../../../../services/sell.service";
import { ticketPaymentComplete } from "../../reports/TicketPaymentComplete";

const useStyles = makeStyles(() => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  backgroundIcon: styles.backgroundIcon,
  label: styles.label,
  table: {
    minWidth: 550,
    maxWidth: 800,
  },
  editIcon: {
    marginLeft: 14,
    fontSize: 25,
    "&:hover": {
      cursor: "pointer",
    },
  },
  paperContainer: {
    width: "auto",
    maxHeight: "300px",
    overflow: "scroll",
    marginBottom: 20,
    border: "2px solid gray",
  },
  header: styles.header,
  row: styles.rowHover,
  chip: styles.chip,
  subtitle: styles.subtitle,
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  highExistence: styles.highExistence,
}));

const RechargeInventoryBySIte = ({
  addAlert,
  detailAlert,
  addItemToCart,
  shoppingCart: { cart },
}) => {
  const classes = useStyles();

  const [balanceObject, setBalanceObject] = useState({});
  const [pendingBalance, setPendingBalance] = useState({});
  const [productCreated, setProductCreated] = useState(false);
  const [queryParams, setQueryParams] = useState(false);
  const [balancesTransferPending, setBalancesTransferPending] = useState([]);

  useEffect(() => {
    loadBalanceTransferProducts();
  }, []);

  const loadBalanceTransferProducts = async () => {
    try {
      const { siteId, id } = AuthService.currentUserValue;
      const params = { siteId, paymentPending: 1 };
      const {
        data,
      } = await ProductService.getProductByBalanceTranferWithParams(params);
      console.log("paymentPending balance ", data);
      if (data.length) {
        setQueryParams({
          ...queryParams,
          siteId,
          userId: id,
          productId: data[0].id,
        });

        setBalancesTransferPending(data);
      }
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs || "Error al recuperar saldos con pago pendiente",
      });
    }
  };

  const handleBalanceSelected = (key, value) => {
    setBalanceObject({ ...balanceObject, [key]: value });
  };

  const handleInputText = ({ target: { name, value } }) => {
    setBalanceObject({ ...balanceObject, [name]: value });
  };

  const handleAddBalanceToCard = async () => {
    if (!balanceObject.balanceCatalogueId) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "Es necesario seleccionar un proveedor de saldo",
      });
      return;
    } else if (Object.values(cart).length) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "info",
        message:
          "Ya tienes artículos agregados en el carrito, favor de eliminar",
      });
      return;
    } else {
      const { siteId } = AuthService.currentUserValue;
      const body = { ...balanceObject, siteId };
      try {
        const { data } = await BalanceTransferService.postBalanceTransfer(body);
        const productBody = {
          productTypeId: "5",
          balanceTransferId: data.id,
        };
        const productCreated = await ProductService.postProduct(productBody);
        addItemToCart({ item: productCreated.data, quantity: 1 });
        setProductCreated(true);
        console.log("productCreated", productCreated.data);
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: error.msgs,
        });
      }
    }
  };

  const handlePaymentMethodSelected = (key, value) => {
    setPendingBalance({ ...pendingBalance, [key]: value });
    setQueryParams({ ...queryParams, [key]: value });
  };

  const handlePayPendingBalance = async (row) => {
    const body = { paymentPending: 0 };
    const balanceId = row.balanceTransferId;
    const { data } = await SellService.getSellByProductId(row.id);
    const sellId = data?.id;

    try {
      const { data, status } = await SellService.updateSell(
        pendingBalance,
        sellId
      );
      if (status === 201) {
        const result = await BalanceTransferService.updateBalanceTransfer(
          body,
          balanceId
        );
        console.log("data pendingBalance", result.data);
        console.log("status pendingBalance", result.status);
        if (result.status === 201) {
          /** Generate paymente complete PDF */
          loadBalanceTransferProducts();
          await ticketPaymentComplete(queryParams);
          addAlert({ showAlert: true });
          detailAlert({
            severity: "success",
            message: "El pago del traspaso de saldo se hizo exitsaomente ",
          });
        }
      }
      console.log("sell data", data);
      console.log("sell status", status);
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({ severity: "error", message: error.msgs });
    }
  };
  return (
    <>
      <Typography variant="h4" component="h4" className={classes.title}>
        Inventario traspasos
      </Typography>

      {balancesTransferPending.length >= 1 && (
        <>
          <Grid item>
            <Typography className={classes.header} style={{ marginTop: 15 }}>
              Traspasos pendientes de pago
            </Typography>
          </Grid>

          <TableContainer>
            <Table className={classes.table} aria-label="customized table">
              <StatelessTableHeadBalanceProduct />

              <TableBody>
                {balancesTransferPending.map((item, i) => (
                  <StyleTableRow key={i} className={classes.row}>
                    <StyledTableCell align="center">
                      {item.balance_transfer.balance_catalogue.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      ${item.balance_transfer.amount}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {customDate(item.updatedAt)}
                    </StyledTableCell>
                    <StyledTableCell>
                      <PaymentMethodSelect
                        paymentMethod={handlePaymentMethodSelected}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Button
                        className={classes.rightButton}
                        disabled={!pendingBalance.paymentMethodId}
                        variant="contained"
                        onClick={() => handlePayPendingBalance(item)}
                        color="primary"
                        endIcon={<MonetizationOnIcon color="secondary" />}
                      >
                        Pagar
                      </Button>
                    </StyledTableCell>
                  </StyleTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      <Grid
        container
        direction="column"
        justify="flex-start"
        spacing={4}
        style={{ marginTop: 10 }}
        alignItems="center"
      >
        <Grid item>
          <Typography className={classes.header}>
            Seleccionar el proveedor del traspaso de saldo
          </Typography>
        </Grid>
        <Grid item>
          <BalanceProvidersSelect cardCategory={handleBalanceSelected} />
        </Grid>
        <Grid item>
          <InputMask
            mask="99999"
            maskChar=""
            value={balanceObject.amount || ""}
            onChange={(e) => handleInputText(e)}
          >
            {() => (
              <TextField
                name="amount"
                placeholder="saldo"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            )}
          </InputMask>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="primary"
            disabled={
              !balanceObject.amount ||
              balanceObject.amount === "0" ||
              productCreated
            }
            type="submit"
            onClick={() => handleAddBalanceToCard()}
            endIcon={
              <AddIcon
                className={classes.backgroundIcon}
                color="primary"
              ></AddIcon>
            }
          >
            Agregar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
  addItemToCart: shoppingCartActions.addItemToCart,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(RechargeInventoryBySIte);
